module.exports = __webpack_public_path__ + "img/aracataca1200.4bf8afed.jpg";